import React from 'react';
import styled from '@emotion/styled';
import List from './List';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding: 30px 0;
  background: ${props => props.theme.colors.primary.lighter};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;

  @media (min-width: ${props =>
      props.theme.breakpoints.s}) and (max-width: ${props =>
      props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 30px 0;
  color: ${props =>
    props.textHighlighted
      ? props.theme.colors.primary.base
      : props.theme.colors.black.base};
`;
const SectionDescription = styled.p`
  font-size: 12px;
  line-height: 28px;
  max-width: 600px;
  text-align: center;
  color: ${props => props.theme.colors.black.base};
`;
const IconsWrapper = styled.div`
  display: flex;
  margin: 40px 0 30px 0;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
    justify-content: center;
    margin: 0;
  }
`;
const Icon = styled.img`
  height: 65px;
  margin: 0 50px;

  @media (min-width: ${props =>
      props.theme.breakpoints.m}) and (max-width: ${props =>
      props.theme.breakpoints.l}) {
    height: 50px;
  }

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    height: 50px;
    margin: 30px;
  }
`;

const IconSvg = props => {
  const { src } = props;
  const IconDisp = styled(src)`
    height: 65px;
    margin: 0 50px;

    @media (min-width: ${props =>
        props.theme.breakpoints.m}) and (max-width: ${props =>
        props.theme.breakpoints.l}) {
      height: 50px;
      width: 50px;
    }

    @media (max-width: ${props => props.theme.breakpoints.m}) {
      height: 50px;
      width: 50px;
      margin: 30px;
    }
  `;
  return <IconDisp />;
};

const ImplementedTechnology = props => {
  const { title, description, iconsPng, iconsSvg } = props.content;
  return (
    <Section>
      <ContentWrapper>
        <SectionTitle>{title}</SectionTitle>
        <SectionDescription>{description}</SectionDescription>
        <IconsWrapper>
          {iconsPng &&
            iconsPng.map((iconSrc, idx) => <Icon key={idx} src={iconSrc} />)}
          {iconsSvg &&
            iconsSvg.map((iconSrc, idx) => <IconSvg key={idx} src={iconSrc} />)}
        </IconsWrapper>
      </ContentWrapper>
    </Section>
  );
};

export default ImplementedTechnology;
